var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("SModalCentered", {
        attrs: {
          title: _vm.$t(
            "teamRequestDetail.modal.client.savedToPendingTeamRequest.title"
          ),
          isOpen: _vm.openApproveModal,
          closeModal: _vm.closeApproveModalHandler,
          customProps: _vm.customModalProps,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "text-body-1 text--text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "teamRequestDetail.modal.client.savedToPendingTeamRequest.body"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "v-container",
                  { staticClass: "p-0" },
                  [
                    _c(
                      "v-row",
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pl-2", attrs: { cols: "12" } },
                          [
                            _c("SButton", {
                              attrs: {
                                action: _vm.closeApproveModalHandler,
                                btnStyle: "primary",
                                sText: _vm.$t(
                                  "teamRequestDetail.modal.client.savedToPendingTeamRequest.primaryButtonText"
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("SModalStemdoerNotAvailable", {
        attrs: {
          stemdoers: _vm.stemdoersNotAvailables,
          isOpen: _vm.isStemdoersNotAvailableModalOpen,
          onClose: _vm.closeStemdoersNotAvailableModal,
        },
      }),
      _vm._v(" "),
      _vm.teamRequest
        ? _c("SModalTeamRequestConfirmation", {
            attrs: {
              teamRequest: _vm.teamRequest,
              isOpen: _vm.isOpen,
              onClose: _vm.handleClose,
              action: _vm.onClickFormModal,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }